import React from "react";
import { Box, FormLabel, TextField } from "@mui/material";

interface TableSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  width?: number;
}

const TableSearch: React.FC<TableSearchProps> = ({
  value,
  onChange,
  placeholder = "Search",
  width = 400,
}) => {
  return (
    <Box className="mt-4 mb-3">
      <FormLabel className="fw-600" sx={{ display: 'block', marginBottom: '8px' }}>
        Search :
      </FormLabel>
      <Box sx={{ position: 'relative', width }}>
        <Box sx={{ 
          position: 'absolute', 
          left: 0, 
          top: '50%', 
          transform: 'translateY(-50%)',
          color: '#999',
          pointerEvents: 'none'
        }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"></circle>
            <path d="m21 21-4.35-4.35"></path>
          </svg>
        </Box>
        <TextField
          placeholder={placeholder}
          variant="standard"
          size="small"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          sx={{ 
            width: '100%',
            '& .MuiInput-root': {
              paddingLeft: '28px',
              '&:before': {
                borderBottom: '1px solid #d3d3d3',
              },
              '&:hover:not(.Mui-disabled):before': {
                borderBottom: '1px solid #999',
              },
              '&:after': {
                borderBottom: '2px solid #09BBE9',
              }
            }
          }}
        />
      </Box>
    </Box>
  );
};

export default TableSearch;